import { render, staticRenderFns } from "./give-proudly-Login.vue?vue&type=template&id=c3177bb2&scoped=true"
import script from "./give-proudly-Login.vue?vue&type=script&lang=js"
export * from "./give-proudly-Login.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-Login.vue?vue&type=style&index=0&id=c3177bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3177bb2",
  null
  
)

export default component.exports